import {emotionStyled, tokens} from '@packages/utilities/styled';

import {View} from '../../View';

export const SearchableListItemGroupView = emotionStyled('div')(
  {},
  {
    componentName: 'SearchableListItemGroup',
  }
);

export const SearchableListLabelView = emotionStyled('div')(
  {
    padding: `${tokens.ui.rowItem.padding.comfortable.vertical} ${tokens.ui.rowItem.padding.comfortable.left}`,
  },
  {
    componentName: 'SearchableListLabel',
  }
);

export const SearchableListBoxView = emotionStyled(View)(
  {
    overflowY: 'auto',
  },
  {
    componentName: 'SearchableListBox',
    variants: {
      hasGroupDividers: {
        true: {
          [`& ${SearchableListItemGroupView}:not(:last-child)::after`]: {
            content: '""',
            display: 'block',
            backgroundColor: '$border1',
            height: 1,
            width: '100%',
            margin: '$1 $0',
          },
        },
      },
      isVirtualized: {
        true: {
          height: 'auto',
          overflow: 'auto',
          position: 'relative',
        },
      },
      shouldRenderTopShadow: {
        true: {
          boxShadow: '$searchableList',
        },
      },
    },
    compoundVariants: [
      {
        conditions: {
          hasGroupDividers: true,
          isVirtualized: true,
        },
        css: {
          [`& ${SearchableListItemGroupView}:not(:last-child)`]: {
            borderBottom: '$border1',
          },
          [`& ${SearchableListItemGroupView}:not(:last-child)::after`]: {
            display: 'none',
          },
          [`& ${SearchableListItemGroupView}:not(:first-child) ${SearchableListLabelView}`]:
            {
              /**
               * Give a little more breathing room between a group divider and the next label in virtualized lists.
               */
              paddingTop: `calc(${tokens.ui.rowItem.padding.comfortable.vertical} + $1)`,
            },
        },
      },
    ],
  }
);
